import { TrSpace } from "../components/TrSpace";
import { FormPageButton } from "../components/FormPageButton";
import { Link } from 'react-router-dom';
import { TrWidthFullText } from "../components/TrWidthFullText";

export const HowToUse = () => {
    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>本にするnoteの記事を選択</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="w-fit">
                            <tbody>
                                <TrWidthFullText text="noteの公式ページから、あなたのクリエイターページを開きます。"/>
                                <TrWidthFullText text="あなたが無料公開しているnoteの記事から、本にする記事のリンクをコピーします。"/>
                                <TrWidthFullText text="※本にする記事は複数でも構いません。"/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                    </div>
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>フォームに必要事項を記入</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="w-fit">
                            <tbody>
                                <TrWidthFullText text="リンクの貼り付けが終わったら、お名前やメールアドレスなどの注文者情報や配送に必要な住所、電話番号などの必要事項を記入してフォームを送信します。"/>
                                <TrWidthFullText text="注文メールが届いた後、メールに記載されている振り込み先に期日までに振り込みをお願いします。"/>
                                <TrWidthFullText text="料金は、初回1冊700円（税込）、2回目以降は1冊1500円（税込）です。"/>
                                <TrWidthFullText text="料金の支払い完了後は、本が届くのを楽しみにお待ちください。"/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                    </div>
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>B５版の文庫本をお届け</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="w-fit">
                            <tbody>
                                <TrWidthFullText text="B5版である182mm × 257mmサイズで、私たちChermoがデザインしたシンプルな装丁を纏った本をお届けします。"/>
                                <TrWidthFullText text="あなたの書いた記事は、和文の文庫本のように縦書きになります。"/>
                                <TrWidthFullText text="また、文章に集中できるように写真やイラストなどの挿絵は使用しません。"/>
                                <TrWidthFullText text="「自分が書いた本」を手に取り読んだ時の感動をお楽しみください。"/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <Link to="/">
                            <FormPageButton text="ホームへ戻る"/>
                        </Link>
                    </div>
                </main>
        </div>
    );
};